module.exports = __webpack_public_path__ + "static/media/expert.03a1b565.png";